import { createProvider } from '@nvision/services/data-provider';

import * as api from './api';
import { normalizeLADClaimFilesForEmailResponse } from './normalize';

export const fetchLADClaimFilesForEmail = createProvider(api.fetchLADClaimFilesForEmail)
  .andThen((res) => normalizeLADClaimFilesForEmailResponse(res))
  .andCatch((error) => {
    if (error instanceof Error && error.name === 'AbortError') {
      console.warn('Fetch claim files for email aborted');
    } else {
      console.error('Fetch claim files for email was failed:', error);
    }
    throw error;
  });
